export default {
  MON: "Segunda-feira",
  TUE: "Terça-feira",
  WED: "Quarta-feira",
  THU: "Quinta-feira",
  FRI: "Sexta-feira",
  SAT: "Sábado",
  SUN: "Domingo",
  HOLI: "Feriados"
};